window.TV2 = window.TV2 || {};

(function () {
  window.TV2.appendScriptIfNotExist = ({ src, async = true }) =>
    new Promise((resolve) => {
      if (!document.querySelector(`script[src^="${src}"]`)) {
        const el = document.createElement("script");
        el.type = "text/javascript";
        el.async = async;
        el.onload = () => resolve();
        el.src = src;
        document.getElementsByTagName("head")[0].appendChild(el);
      } else {
        resolve();
      }
    });

  window.TV2.elementIsInView = (el, triggerOffset) => {
    const scroll = window.scrollY || window.pageYOffset;
    const boundsTop = el.getBoundingClientRect().top + scroll;
    const buffer = triggerOffset || el.clientHeight / 3;

    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    };

    const bounds = {
      top: boundsTop + buffer,
      bottom: boundsTop + el.clientHeight - buffer,
    };

    return (
      (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
      (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
    );
  };

  window.TV2.getReadableDuration = (duration) => {
    let min;
    let sec;
    let hours;
    let t;
    if (duration && duration !== null) {
      min = parseInt(duration / 60, 10);
      sec = duration % 60;
      hours = parseInt(min / 60, 10);
      if (sec > 0 || min > 1 || hours > 1) {
        t = "";
        if (hours > 0) {
          min %= 60;
          t += `${hours}:`;
        }
        if (hours > 0) {
          if (min < 10) {
            t += 0;
          }
        }
        t += `${min}:${sec < 10 ? "0" : ""}${sec}`;
        return t;
      }
    }
    return "";
  };

  window.TV2.timeSince = (timeStamp) => {
    const now = new Date();
    const secondsPast = (now.getTime() - timeStamp.getTime()) / 1000;
    if (secondsPast < 60) {
      return `${parseInt(secondsPast, 10)} sekunder siden`;
    }
    if (secondsPast < 3600) {
      return `${parseInt(secondsPast / 60, 10)} minutter siden`;
    }
    if (secondsPast <= 86400) {
      return `${parseInt(secondsPast / 3600, 10)} timer siden`;
    }
    if (secondsPast > 86400 && secondsPast < 86400 * 30) {
      return `${parseInt(secondsPast / 86400, 10)} dager siden`;
    }

    const day = timeStamp.getDate();
    const month = timeStamp.getMonth() + 1;
    const year = timeStamp.getFullYear();
    return `${day < 10 ? `0${day}` : day}.${
      month < 10 ? `0${month}` : month
    }.${year}`;
  };

  window.TV2.getCookieValue = (key) => {
    const cookies = document.cookie;
    const tmpKey = `${key}=`;
    let start = cookies.indexOf(`; ${tmpKey}`);

    if (start === -1) {
      start = cookies.indexOf(tmpKey);
      if (start || start !== 0) return null;
    } else {
      start += 2;
    }

    let end = document.cookie.indexOf(";", start);

    if (end === -1) {
      end = cookies.length;
    }

    return unescape(cookies.substring(start + tmpKey.length, end));
  };

  window.TV2.dragToScroll = (containerEl) => {
    let drag = false;
    let pos = { x: 0, left: 0 };

    containerEl.addEventListener("mousedown", (e) => {
      drag = true;
      pos = {
        x: e.clientX,
        left: containerEl.scrollLeft,
      };
    });
    containerEl.addEventListener("mouseup", () => {
      drag = false;
    });
    containerEl.addEventListener("mousemove", (e) => {
      if (!drag) return;
      const dx = e.clientX - pos.x;
      // eslint-disable-next-line no-param-reassign
      containerEl.scrollLeft = pos.left - dx;
    });
  };

  window.TV2.createObserver = (element, callback, _options) => {
    const options = {
      ..._options,
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(element);
  };

  window.TV2.isFacebookInApp = () => {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
  };

  window.TV2.debounced = (fn, delay) => {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        fn(...args);
        timerId = null;
      }, delay);
    };
  };

  window.TV2.throttle = (fn, delay) => {
    let time = Date.now();
    return function () {
      if (time + delay - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  };
})();
